import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import { useSearchParams } from "react-router-dom";
import TallyEmbed from "../components/TallyEmbed";

function DigitalConnect() {
  const [searchParams] = useSearchParams();
  const title = "Digital Connect | DataPulse AI";

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Our Blog" },
    { to: "/get-in-touch", label: "Support" },
  ];

  return (
    <>
      <Helmet>
        <title>{title} | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <style>
        {`
        .popular-badge {
            background-color: #00ABE4; /* DataPulse Cyan */
            color: #FFFFFF;
            font-size: 0.7rem;
            font-weight: 700;
            padding: 0.25rem 0.75rem;
            border-radius: 0 0 0 0.375rem; /* Rounded bottom-left */
            position: absolute;
            top: 0;
            right: 0;
            text-transform: uppercase;
        }
        `}
      </style>

      <div className="h-screen w-screen overflow-hidden flex flex-col">
        <div id="header" className="z-10 bg-white">
          <Header links={navLinks} />
        </div>
      </div>


      <section id="digitalPlans" className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-screen-xl px-4 py-32 mx-auto lg:py-8 lg:px-6 text-center">
          <div className="mx-auto text-center flex flex-col items-center">
            <div className="flex items-center justify-center gap-4">
              <a href="https://www.mydatapulse.co.uk/network" target="_blank" rel="noreferrer">
                {/* <img
                  src="/icons/qr_network.png"
                  alt="Digital Connect Left"
                  className="h-20 object-contain hover:bg-blue-300"
                /> */}
              </a>
              <div>
                <h2 className="text-4-5xl font-extrabold tracking-tight text-gray-900">
                  Digital Connect<br/>
                  <span className="text-blue-600 font-extrabold text-3xl">Scan. Connect. Convert.</span>
                </h2>
                <p className="font-light text-gray-500 sm:text-xl">
                  Empower your team with a digital identity built for the future of business. <br/>
                  Effortless intros. Smarter networking. Made for the moment.
                </p>
              </div>

              <a href="https://www.mydatapulse.co.uk/network" target="_blank" rel="noreferrer">
                {/* <img
                src="/icons/qr_network.png"
                alt="Digital Connect Right"
                className="h-20 object-contain hover:bg-blue-300"
                /> */}
              </a>
            </div>

          </div>


          <TallyEmbed/>
          </div>
          <div className="">
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
              All pricing is costed on a per employee basis. For enterprise teams, custom domains, or advanced features, please contact us directly for bespoke pricing.
            </p>
          <br/>
        </div>
      </section>
      {/* <!-- End block --> */}



    </>
  );
}

export default DigitalConnect;
